import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteFindingMutation } from '#/graphql/types';
import { deleteFinding } from '#/graphql/mutations';
import { get } from 'lodash';
import { GET_ASSET_RELATED_COUNTS } from '#/modules/asset/hooks/useAssetRelatedCountsQuery';

const q = gql(deleteFinding);

const useFindingDelete = () => {
  const [mutation, result] = useMutation<DeleteFindingMutation>(q);
  const deleteFinding = useCallback(
    async (itemId: string, assetId?: string) => {
      const refetchQueries: { query: typeof GET_ASSET_RELATED_COUNTS; variables?: { assetId: string } }[] = [];

      if (assetId) {
        refetchQueries.push({ query: GET_ASSET_RELATED_COUNTS, variables: { assetId } });
      }

      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteFinding.data', undefined);
    },
    [mutation],
  );

  return { deleteFinding, result };
};

export default useFindingDelete;
